"use strict";

/**
 * 
 * @param {15位或者18位的身份证号，只返回一个字符串“男”或者“女”} str 
 */

module.exports = function (str) {
  if (!str) return "";
  if (str.length != 15 && str.length != 18) return "";
  var a = void 0;
  if (str.length == 15) {
    a = str.substr(14, 1);
  }
  if (str.length == 18) {
    a = str.substr(16, 1);
  }
  if (a % 2 == 0) {
    return "女";
  } else {
    return "男";
  }
};